module.exports = __webpack_public_path__ + "img/pro6.38909ff7.jpg";